import { render, staticRenderFns } from "./AtalhoCadastros.vue?vue&type=template&id=6380a994"
import script from "./AtalhoCadastros.vue?vue&type=script&lang=js"
export * from "./AtalhoCadastros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports